import React from 'react'
import {Text, TextTypography} from 'wix-ui-tpa/cssVars'
import {classes} from './description.st.css'

export const Description = props => <Text typography={TextTypography.runningText} {...props} className={classes.root} />
